const _ = require('lodash');

export const convertMSToDurationString = (ms) => {
  const hours = ms / 3600e3;
  return convertHoursToDurationString(hours);
};

export const getDateString = (date) => {
  let dd = date.getDate();
  let mm = date.getMonth() + 1;
  const yyyy = date.getFullYear();
  if (dd < 10) {
    dd = '0' + dd;
  } 
  if (mm < 10) {
    mm = '0' + mm;
  } 
  return `${yyyy}-${mm}-${dd}`;
};

export const convertHoursToDurationString = (hours) => {
  const minutes = Math.round((hours - Math.floor(hours)) * 60);
  return `${Math.floor(hours)}:${_.padStart(String(minutes), 2, '0')}`;
};
